import React from 'react';
import { CheckedCircle, ErrorCircle } from '@tpr/icons';
var StatusIcon = function (_a) {
    var link = _a.link, sectionCompleteLabel = _a.sectionCompleteLabel, sectionIncompleteLabel = _a.sectionIncompleteLabel;
    return link.completed ? (React.createElement(CheckedCircle, { cfg: { fill: 'success.1' }, ariaLabel: sectionCompleteLabel })) : (React.createElement(ErrorCircle, { cfg: { fill: link.disabled ? 'danger.1' : 'danger.2' }, ariaLabel: sectionIncompleteLabel }));
};
export default React.memo(StatusIcon);
//# sourceMappingURL=StatusIcon.js.map